<template>
  <view-wrapper>
    <div class="flex-grow w-full px-6 pt-10 md:px-32">

      <sub-navbar @navigate="navigate" :action="$route.params.action"/>

      <text-input
        :isPassword="true"
        :value.sync="token"
        label="Security Token"
        id="token"
      />

      <hr class="mb-5">

      <!-- Delete -->
      <delete-section
        @delete-items="deleteItems"
        :loading="httpRequestInProgress"
        :items="items"
        :itemsToDelete.sync="itemsToDelete"
        v-if="$route.params.action == 'delete'"
      />

      <!-- Edit -->
      <edit-section
        @load-edit-item="loadEditItem"
        @edit-item="editItem"
        :items="items"
        :item="item"
        :loading="httpRequestInProgress"
        :showEditItem.sync="showEditItem"
        v-if="$route.params.action == 'edit'"
      />

      <!-- Add -->
      <add-section
        @add-item="addItem"
        :item.sync="item"
        :disabled="httpRequestInProgress"
        v-if="$route.params.action == 'create'"
      />

    </div>

  </view-wrapper>
</template>

<script>
import ViewWrapper from '../components/ViewWrapper.vue';
import SubNavbar from '../components/Admin/SubNavbar.vue';
import TextInput from '../components/Admin/TextInput.vue';
import DeleteSection from '../components/Admin/DeleteSection.vue';
import EditSection from '../components/Admin/EditSection.vue';
import AddSection from '../components/Admin/AddSection.vue';
import data from '../assets/json/data.json';

import {
  createItems, editItems, getItem, deleteImg, uploadBase64Img, getItems, deleteItems,
} from '../api/item';

const cloneDeep = require('lodash.clonedeep');

export default {
  name: 'admin',
  components: {
    ViewWrapper,
    DeleteSection,
    EditSection,
    AddSection,
    SubNavbar,
    TextInput,
  },
  data() {
    return {
      httpRequestInProgress: false,
      item: {},
      emptyItem: {
        id: '',
        name: '',
        nameIsValid: true,
        category: '',
        categoryIsValid: true,
        subCategory: '',
        subcategoryIsValid: true,
        description: '',
        descriptionIsValid: true,
        images: [],
        filesIsValid: true,
      },
      items: [],
      showEditItem: false,
      categories: data.categories,
      subcategories: data.subcategories,
      itemsToDelete: [],
      displayModal: false,
      token: localStorage.getItem('token'), // ls = local storage
    };
  },
  methods: {
    async addItem() {
      try {
        this.httpRequestInProgress = true;
        if (!this.itemIsValid()) throw new Error('Invalid fields');
        const promises = [];
        const newItem = this.wrapVerifiedItem();
        await this.sendNewItemToServer(newItem);
        promises.push(this.saveImages());
        promises.push(this.deleteImages());
        await Promise.all(promises);
        this.configurePage();
        this.storesToken();
      } catch (error) {
        console.log(error);
      } finally { this.httpRequestInProgress = false; }
    },
    async editItem() {
      try {
        this.httpRequestInProgress = true;
        if (!this.itemIsValid()) throw new Error('Invalid fields');
        const promises = [];
        const editedItem = this.wrapVerifiedItem();
        await this.sendEditedItemToServer(editedItem);
        promises.push(this.saveImages());
        promises.push(this.deleteImages());
        await Promise.all(promises);
        this.showEditItem = false;
        this.configurePage();
        this.storesToken();
      } finally { this.httpRequestInProgress = false; }
    },
    async deleteItems() {
      if (this.httpRequestInProgress || this.items.length == 0) return;
      this.itemsToDelete = JSON.parse(JSON.stringify(this.itemsToDelete));
      this.httpRequestInProgress = true;
      deleteItems(this.itemsToDelete, this.token)
        .then(() => {
          this.items = this.items.filter((item) => !this.itemsToDelete.includes(item.id));
          document.querySelectorAll('input').forEach((checkbox) => {
            // eslint-disable-next-line no-param-reassign
            checkbox.checked = false;
          });
          this.itemsToDelete = [];
        })
        .catch(() => {
          alert('There was an issue deleteing the items. Ensure the correct token security token is used');
        })
        .finally(() => {
          this.httpRequestInProgress = false;
        });
    },
    loadEditItem(id) {
      this.httpRequestInProgress = true;
      getItem(id).then((itemData) => {
        this.item = {
          ...this.item,
          ...itemData,
        };
      })
        .finally(() => { this.httpRequestInProgress = false; });
    },
    itemIsValid() {
      // check to see if all inputs are valid
      let valid = true;
      if (this.item.name.length < 1) {
        this.item.nameIsValid = false;
        valid = false;
      }
      if (this.item.category.length < 1) {
        this.item.categoryIsValid = false;
        valid = false;
      }
      if (this.item.subCategory.length < 1) {
        this.item.subcategoryIsValid = false;
        valid = false;
      }
      if (this.item.description < 1) {
        this.item.descriptionIsValid = false;
        valid = false;
      }
      if (this.item.images.length == 0) {
        this.item.filesIsValid = false;
        valid = false;
      }
      return valid;
    },
    // Helpers
    wrapVerifiedItem() {
      const newItem = {
        id: this.item.id,
        name: this.item.name,
        category: this.item.category,
        subCategory: this.item.subCategory,
        description: this.item.description,
        images: [],
      };
      this.item.images.forEach((imgObj) => {
        if (imgObj.deleted == false) {
          newItem.images.push({
            id: imgObj.id,
            extension: imgObj.extension,
          });
        }
      });
      return newItem;
    },
    async saveImages() {
      const promises = [];
      this.item.images.forEach((imgObj) => {
        if (imgObj.new == true && imgObj.deleted == false) {
          console.log(imgObj);
          promises.push(uploadBase64Img(
            imgObj.id,
            imgObj.extension,
            imgObj.base64,
            this.token,
          ));
        }
      });
      return Promise.all(promises)
        .catch(() => {
          throw new Error('Unable to upload images');
        });
    },
    async deleteImages() {
      const promises = [];
      this.item.images.forEach((imgObj) => {
        if (imgObj.new == false && imgObj.deleted == true) {
          promises.push(deleteImg(
            imgObj.id,
            this.token,
          ));
        }
      });
      return Promise.all(promises)
        .catch(() => {
          throw new Error('Unable to delete images');
        });
    },
    async sendEditedItemToServer(editedItem) {
      return editItems([editedItem], this.token)
        .catch(() => {
          console.log('BAD');
          throw new Error('Problem uploading the edited item. Ensure you are using the right token');
        });
    },
    async sendNewItemToServer(newItem) {
      return createItems([newItem], this.token)
        .catch(() => {
          throw new Error('Problem with uploading the new item. Ensure you are using the right token');
        });
    },
    storesToken() { localStorage.setItem('token', this.token); },
    resetItem() {
      const lastCategory = this.item.category;
      const lastSubcategory = this.item.subCategory;
      this.item = cloneDeep(this.emptyItem);
      const defaultCategory = this.categories[0];
      this.item.category = lastCategory == undefined ? defaultCategory : lastCategory;
      const defaultSubcategory = this.subcategories[this.item.category][0].name;
      this.item.subCategory = lastSubcategory == undefined ? defaultSubcategory : lastSubcategory;
    },
    async configurePage() {
      if (!['create', 'edit', 'delete'].includes(this.$route.params.action.toLowerCase())) {
        this.$router.push({ path: '/admin/create' });
      }
      this.resetItem();
      this.itemsToDelete = [];
      this.items = await getItems();
      this.items.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      });
    },
    navbar(action) {
      const isActive = this.$route.params.action == action;
      return {
        active: isActive,
        underline: isActive,
        'font-medium': isActive,
      };
    },
    navigate(action) {
      this.configurePage();
      this.$router.push({ path: `/admin/${action}` });
    },
  },
  watch: {
    $route() { this.showEditItem = false; },
  },
  mounted() { this.configurePage(); },
};
</script>
